// パスキーの登録・ログインで共通の、サーバーとの JSON のやりとり。
// 失敗時はサーバーが返した文言(error)を持つ PasskeyRequestError を投げる。
export class PasskeyRequestError extends Error {}

export async function postJSON(url, body = {}) {
  const response = await fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
    },
    body: JSON.stringify(body)
  })
  const json = await response.json().catch(() => ({}))
  if (!response.ok) throw new PasskeyRequestError(json.error || "")
  return json
}

// 利用者が閉じた・別の操作で中断した(AbortError)は案内を出さない
export function isAbort(error) {
  return error?.name === "AbortError"
}

export function isCancel(error) {
  return error?.name === "NotAllowedError"
}
